import { render, staticRenderFns } from "./WSearchBox.vue?vue&type=template&id=1a935272&"
import script from "./WSearchBox.vue?vue&type=script&lang=ts&"
export * from "./WSearchBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports